import React from 'react';
import Hero from '../components/Hero';

function HomePage() {
  return <Hero />;
}

export default HomePage;
